import classNames from "classnames";
import { FORM_ERROR } from "final-form";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ISearchOptions } from "../../app/models/search";
import { RootStoreContext } from "../../app/stores/rootStore";
import CheckboxInput from "../common/CheckboxInput";
import TextInput from "../common/TextInput";
import { use } from "i18next";
import { toast } from "react-toastify";
import "../../assets/scss/my-custom.scss";

interface ISearchFormValues {
  searchQuery: string;
  searchInMeetings: boolean;
  searchInArchives: boolean;
  searchInBoards: boolean;
  searchTitlesOnly: boolean;
  searchInDoc: boolean;  
}
  

const SearchForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { search, setSelectedSearchPage , enabledRepository,setStoredSearchFormValues,storedsearchFormValues} = rootStore.playerStore;
  const{ canViewODG }= rootStore.tenantStore;
  const { enabledArchiveButton ,IsStoredSearchResults} = rootStore.playerStore;
  const { theme } = rootStore.commonStore;
  const { isMobileMediaQuery} = rootStore.responsiveStore;
  
  const [t] = useTranslation(["features"], translationHookOptions);

 const initializeFormValues = () => {
  if(IsStoredSearchResults){
    return {
      searchQuery: storedsearchFormValues!.searchQuery,
      searchInMeetings: storedsearchFormValues!.searchInMeetings,
      searchInArchives: storedsearchFormValues!.searchInArchives ,
      searchInBoards: storedsearchFormValues!.searchInBoards,
      searchTitlesOnly: storedsearchFormValues!.searchTitlesOnly,
      searchInDoc: enabledRepository ? storedsearchFormValues!.searchInDoc : false,
    };
  }else{
    return {
      searchQuery: "",
      searchInMeetings: canViewODG ? true : false,
      searchInArchives: enabledArchiveButton ? true : false,
      searchInBoards: true,
      searchTitlesOnly: false,
      searchInDoc: false,
    };
  }
  };

const [formValues, setFormValues] = useState<ISearchFormValues>(initializeFormValues);

useEffect(() => { 

return () => {}

});


  return (
    <FinalForm
      initialValues={formValues}
      onSubmit={(values: ISearchOptions) =>
        search(values)
          .then(() => {
            setSelectedSearchPage(0);
            setStoredSearchFormValues(values);
            setFormValues({
              searchQuery: values.searchQuery,
              searchInMeetings: canViewODG ?values.searchInMeetings: false,
              searchInArchives: enabledArchiveButton ?values.searchInArchives: false,
              searchInBoards: values.searchInBoards,
              searchTitlesOnly: values.searchTitlesOnly,
              searchInDoc: enabledRepository ?values.searchInDoc: false,
            });
          })
          .catch((error) => ({
            [FORM_ERROR]: error,
          }))
      }
      validate={(values) => {
        let errors = {};
        let errorNum = 0;

        // if (!values.searchInMeetings && !values.searchInBoards) errorNum++;
        if (!values.searchInArchives && !values.searchInMeetings && !values.searchInBoards  && !values.searchInDoc) errorNum++;
        if (!values.searchQuery || values.searchQuery.length < 3) errorNum++;

        if (errorNum === 0) return errors;
        else return { count: errorNum };
      }}
      render={({
        handleSubmit,
        invalid,
        pristine,
      }) => (
        <Form onSubmit={handleSubmit} role="form">
          <Row>
            <Col xs={8}>
              <Field
                name="searchQuery"
                component={TextInput}
                placeholder={t("search_page_textbox_placeholder")}
                autoComplete="off"
                className={classNames("searchInput")}
              />
            </Col>
            <Col xs={4}>
              <Button
               style={{marginTop:"5px"}}
                disabled={invalid || pristine}
                className={classNames(
                  isMobileMediaQuery? "searchMobileBtn":"searchBtn",
                  "genericButton",
                  `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                    theme!.buttonTextColor
                  }`
                )}
                type="submit"
              >
                <i  style={{paddingTop:"6px", paddingBottom:"5px" }}className="fas fa-search fa-lg m-auto"></i>
              </Button>
            </Col>
          </Row>
          <Row className="mt-2" style={{width:"67%"}}>
            {canViewODG && (<>
              <Col >
              <Field
                id="searchInMeetings"
                name="searchInMeetings"
                component={CheckboxInput}
                type="checkbox"
                label={t("search_page_meetings_checkbox")}
              />
            </Col>
            </>)}
            <Col >
              <Field
                id="searchInBoards"
                name="searchInBoards"
                component={CheckboxInput}
                type="checkbox"
                label={t("search_page_board_checkbox")}
              />
            </Col>
            {enabledRepository && (
              <>
                <Col>
                  <Field
                  id="searchInDoc"
                  name="searchInDoc"
                  component={CheckboxInput}
                  type="checkbox"
                  label={t("search_page_board_doc")}
                />
                </Col>
              </>
            )}
            <Col>
              {enabledArchiveButton && (<>
                <Field
                id="searchInArchives"
                name="searchInArchives"
                component={CheckboxInput}
                type="checkbox"
                label={t("search_page_archive_doc")}
              />
              </>)}
            </Col>
            <Col  style={{fontWeight: "bold"}} >
            {/* <Col style={{textAlign: "end"}}> */}
              <Field
              
                id="searchTitlesOnly"
                name="searchTitlesOnly"
                component={CheckboxInput}
                type="checkbox"
                label={t("search_page_titlesonly_checkbox")}
              />
            </Col>
           
          </Row>
        </Form>
      )}
    />
  );
};

export default observer(SearchForm);
